// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    // Search Profile Email Alerts
    initSearchProfileAlerts();
}]);

function initSearchProfileAlerts(){

    // redirect to saved searches
    // $('#wrapper').on('click', '.btn-editAlert', function(e){
    //     window.location.href = '/login/saved-searches/';
    // });
    // // save search to receive email alerts
    // $('#wrapper').on('click', '.btn-setAlert', function(e){

    //     var btn = $(this);

    //     // get advanced search form
    //     var form = $('#form-advancedsearch');

    //     // serialize form data
    //     formData = form.serializeArray();

    //     // convert to Object
    //     formObj = formData.reduce(function (tmp, entry) {
    //         tmp[entry.name] = entry.value;

    //         return tmp;
    //     }, {})


    //     // convert form values to JSON string
    //     jsonStr = JSON.stringify(formObj);

    //     // console.log(jsonStr);

    //     // submit form values
    //     // if customer is loggedin
    //     // if ($('body').hasClass('loggedin')) {
    //     //     $.ajax({
    //     //         url: '/app/post/',
    //     //         method: 'post',
    //     //         data: {
    //     //             'saction' : 'ADDSEARCHALERT',
    //     //             'search_criteria' : jsonStr
    //     //         },
    //     //         dataType: 'json',
    //     //         beforeSend: function(xhr) {
    //     //             btn.attr('disabled', true).addClass('disabled');
    //     //         }
    //     //     }).done(function(response) {

    //     //         if(response.success){
    //     //             btn.removeClass('btn-setAlert').addClass('btn-editAlert').find('span').text('Edit alerts');
    //     //         }
    //     //         btn.attr('disabled', false).removeClass('disabled');

    //     //     });
    //     // }
    // });
}